import React from 'react'
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link } from 'react-router-dom';
import logo from '../logo.png'


export default function Footer() {
    const footerNav = [
        {
            id: '1',
            label: 'AI Agents ',
            link: '/product'
        },
        {
            id: '2',
            label: 'LNVS Fintech API ',
            link: '/product'
        },
        {
            id: '3',
            label: 'Deployable Solutions ',
            link: '/product'
        },
    ]

    const quickLink = [
        {
            id: '1',
            label: 'About Us ',
            link: '/aboutus'
        },
        {
            id: '2',
            label: 'Products ',
            link: '/product'
        },
        {
            id: '3',
            label: 'Contact Us ',
            link: '/contact'
        }

    ]

    const socialIconList = [
        {
            name: <FacebookIcon />,
            url: 'https://www.facebook.com/people/LNVS-fintech/61589594152235/'
        },
        {
            name: <LinkedInIcon />,
            url: "https://www.linkedin.com/company/lnvs-fintech/about/"
        },
        {
            name: <YouTubeIcon />,
            url: "https://www.youtube.com/@LNVSfintech"
        },
        {
            name: <InstagramIcon />,
            url: "https://www.instagram.com/lnvsfintech_official/"
        },
    ]
    return (
        <footer className="bg-gradient-to-b from-[#0b1220] to-[#0a0f1a] text-gray-300 py-16 px-6">
            <div className="max-w-7xl mx-auto">
                {/* Glass Container */}
                <div className="">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

                        {/* Left Section */}
                        <div>
                            <div className="">
                                <div className="w-36 h-30 ">
                                    <img src={logo} alt='logo' />
                                </div>
                                <h3 className="text-white font-semibold pt-4">LNVS FINTECH PRIVATE LIMITED</h3>
                            </div>


                            {/* Social Icons */}
                            <div className="flex gap-4 mt-6">
                                {socialIconList.map((Icon, i) => (
                                    <Link key={i} to={`${Icon.url}`}>
                                        <div
                                            className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition"
                                        >
                                            {Icon.name}
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* Loan Products */}
                        <div>
                            <h3 className="text-white font-semibold mb-4">Our Products</h3>
                            <ul className="space-y-2 text-sm">
                                {
                                    footerNav.map((item) => {
                                        return (
                                            <Link to={item.link}>
                                                <li key={item.id} className="hover:text-white cursor-pointer transition py-1">
                                                    {item.label}
                                                </li>
                                            </Link>

                                        )
                                    })
                                }

                            </ul>
                        </div>

                        {/* Company */}
                        <div>
                            <h3 className="text-white font-semibold mb-4">Company</h3>
                            <ul className="space-y-2 text-sm">
                                {
                                    quickLink.map((item) => {
                                        return (
                                            <Link to={item.link}>
                                                <li key={item.id} className="hover:text-white cursor-pointer transition py-1">
                                                    {item.label}
                                                </li>
                                            </Link>

                                        )
                                    })
                                }


                            </ul>
                        </div>

                        {/* Contact */}
                        <div>
                            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
                            <ul className="space-y-4 text-sm">
                                <li className="flex items-center gap-3">
                                    <EmailIcon size={18} />
                                    info@lnvstech.com
                                </li>
                                <li className="flex items-center gap-3">
                                    <LocalPhoneIcon size={18} />
                                    +91: 8796121151
                                </li>
                                <li className="flex items-start gap-3">
                                    <LocationOnIcon size={18} />
                                    <span>
                                        15<sup>th</sup> floor Best Sky Tower Netaji Subhash Place Pitampura Delhi 110034
                                        <br />

                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Bottom */}
                    <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
                        <p>© 2026  LNVS Fintech All rights reserved.</p>

                        <div className="flex gap-6 mt-4 md:mt-0">
                            <Link to={'/privacy-policy'}>
                                <span className="hover:text-white cursor-pointer transition" >
                                    Privacy Policy
                                </span>
                            </Link>

                            <Link to={'/terms-and-conditions'}>
                                <span className="hover:text-white cursor-pointer transition" >
                                    Terms of Service
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
